import enAdmin from './en/admin';
import enAuth from './en/auth';
import enChat from './en/chat';
import enCommon from './en/common';
import enPreferences from './en/preferences';
import enReports from './en/reports';
import enTour from './en/tour';
import esAdmin from './es/admin';
import esAuth from './es/auth';
import esChat from './es/chat';
import esCommon from './es/common';
import esPreferences from './es/preferences';
import esReports from './es/reports';
import esTour from './es/tour';
import frAdmin from './fr/admin';
import frAuth from './fr/auth';
import frChat from './fr/chat';
import frCommon from './fr/common';
import frPreferences from './fr/preferences';
import frReports from './fr/reports';
import frTour from './fr/tour';

export const TRANSLATION_NAMESPACES = [
  'common',
  'auth',
  'chat',
  'preferences',
  'tour',
  'admin',
  'reports',
] as const;

export type TranslationNamespace = (typeof TRANSLATION_NAMESPACES)[number];

export const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    chat: enChat,
    preferences: enPreferences,
    tour: enTour,
    admin: enAdmin,
    reports: enReports,
  },
  es: {
    common: esCommon,
    auth: esAuth,
    chat: esChat,
    preferences: esPreferences,
    tour: esTour,
    admin: esAdmin,
    reports: esReports,
  },
  fr: {
    common: frCommon,
    auth: frAuth,
    chat: frChat,
    preferences: frPreferences,
    tour: frTour,
    admin: frAdmin,
    reports: frReports,
  },
} as const;